import { render } from "./AuctionDetail.vue?vue&type=template&id=30a4a7d7"
import script from "./AuctionDetail.vue?vue&type=script&lang=js"
export * from "./AuctionDetail.vue?vue&type=script&lang=js"

import "./AuctionDetail.vue?vue&type=style&index=0&id=30a4a7d7&lang=scss"

import exportComponent from "D:\\myWork\\SAAS\\Group-Carwins-H5-1.0\\carwins-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__